import { render, staticRenderFns } from "./PlayerDashboardItem.vue?vue&type=template&id=ae5d3a68"
import script from "./PlayerDashboardItem.vue?vue&type=script&lang=js"
export * from "./PlayerDashboardItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports